<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="bg_default"
          v-bind="attrs"
          v-on="on"
          fab
          depressed
          small
          dark
          @click="$router.go(-1)"
          ><v-icon>mdi-reply</v-icon></v-btn
        >
      </template>
      <span>Back</span>
    </v-tooltip>
    <div class="d-flex justify-center" v-if="dataSet">
      <div class="_60_w mt-3">
        <title-page title="Create Course" class="mb-3" />
        <v-card color="rounded_max mb-3" elevation="1">
          <div :class="`cat_${dataSet.course_categories_id} _100pxh`">
            <div class="pa-3">
              <h3 class="white--text">
                {{ dataSet.title }}
              </h3>
            </div>
          </div>
          <div class="pa-3">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <div class="pa-2">
                  <p class="default_txt">Select Category</p>
                  <v-select
                    dense
                    hide-details
                    :items="categories"
                    item-text="txt"
                    item-value="val"
                    v-model="dataSet.course_categories_id"
                    placeholder="Category Course"
                  ></v-select>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="pa-2">
                  <p class="default_txt">Course Name</p>
                  <v-text-field
                    dense
                    v-model="dataSet.title"
                    placeholder="Type Here"
                    hide-details
                    color="green"
                  ></v-text-field>
                </div>
              </v-col>

              <v-col cols="12" md="12">
                <div class="pa-2">
                  <p class="default_txt">Description</p>
                  <v-textarea
                    v-model="dataSet.description"
                    dense
                    placeholder="Type Here"
                    hide-details
                    rows="3"
                    auto-grow
                    color="green"
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-overlay :absolute="true" color="white" :value="loading">
          </v-overlay>
        </v-card>

        <v-card color="rounded_max mb-3" elevation="1">
          <div class="pa-3">
            <div class="pt-2 d-flex align-center">
              <v-icon class="mr-2">mdi-calendar-month-outline</v-icon>
              <h3>Start</h3>
            </div>
            <v-row no-gutters>
              <v-col cols="12" md="7">
                <div class="pa-2">
                  <p class="default_txt">Start Date</p>
                  <v-menu
                    v-model="calendar1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataSet.start_course.fake.start_date"
                        placeholder="Click here"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataSet.start_course.fake.start_date"
                      @input="calendar1 = false"
                      :min="$date().add(1, 'day').format('YYYY-MM-DD')"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="5">
                <div class="pa-2">
                  <p class="default_txt">Start Time</p>
                  <v-menu
                    ref="menu1"
                    v-model="time1"
                    :close-on-content-click="false"
                    :return-value.sync="dataSet.start_course.fake.start_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataSet.start_course.fake.start_time"
                        placeholder="Click Here"
                        append-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="time1"
                      v-model="dataSet.start_course.fake.start_time"
                      full-width
                      @click:minute="
                        $refs.menu1.save(dataSet.start_course.fake.start_time)
                      "
                    ></v-time-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>

            <div class="pt-2 d-flex align-center">
              <v-icon class="mr-2">mdi-calendar-month-outline</v-icon>
              <h3>End</h3>
            </div>
            <v-row no-gutters>
              <v-col cols="12" md="7">
                <div class="pa-2">
                  <p class="default_txt">End Date</p>
                  <v-menu
                    v-model="calendar2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataSet.end_course.fake.end_date"
                        :disabled="!dataSet.start_course.fake.start_date"
                        placeholder="Click here"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataSet.end_course.fake.end_date"
                      @input="calendar2 = false"
                      :min="
                        $date(dataSet.start_course.fake.start_date).format(
                          'YYYY-MM-DD'
                        )
                      "
                    ></v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="5">
                <div class="pa-2">
                  <p class="default_txt">End Time</p>
                  <v-menu
                    ref="menu2"
                    v-model="time2"
                    :close-on-content-click="false"
                    :return-value.sync="dataSet.end_course.fake.end_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataSet.end_course.fake.end_time"
                        :disabled="!dataSet.start_course.fake.start_date"
                        placeholder="Click Here"
                        append-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="time2"
                      v-model="dataSet.end_course.fake.end_time"
                      full-width
                      @click:minute="
                        $refs.menu2.save(dataSet.end_course.fake.end_time)
                      "
                    ></v-time-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-overlay :absolute="true" color="white" :value="loading">
          </v-overlay>
        </v-card>
        <div class="d-flex justify-end mb-5">
          <v-btn
            v-if="!loading"
            class="bg_default text-capitalize rounded-lg"
            depressed
            dark
            @click="updateData"
            >Save</v-btn
          >
          <v-btn
            v-if="loading"
            class="bg_default text-capitalize rounded-lg"
            depressed
            dark
            >Saving...</v-btn
          >
        </div>
        <v-card color="rounded_max mb-3" elevation="1">
          <div class="pa-3 d-flex align-center">
            <v-icon class="mr-2" color=" red">mdi-alert</v-icon>
            <h3>Danger Zone</h3>
          </div>
          <div class="pa-3">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <div class="pa-2">
                  <p class="default_txt">Status Course</p>
                  <div class="d-flex align-center">
                    <v-icon
                      v-if="dataSet.status == 1"
                      @click="switchStatus(dataSet)"
                      class="mr-2"
                      large
                      color="blue"
                      style="cursor: pointer"
                      >mdi-toggle-switch</v-icon
                    >
                    <v-icon
                      v-if="dataSet.status == 0"
                      @click="switchStatus(dataSet)"
                      large
                      class="mr-2"
                      style="cursor: pointer"
                      >mdi-toggle-switch-off-outline</v-icon
                    >
                    <p class="default_txt">
                      {{ dataSet.status == 1 ? "Active" : "No Active" }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div class="pa-2">
                  <p class="default_txt">Delete Course</p>
                  <v-btn
                    color="error"
                    @click="deleteCourse"
                    class="mt-3 text-capitalize"
                    >Delete</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </div>
          <v-overlay :absolute="true" color="white" :value="loading">
          </v-overlay>
        </v-card>
      </div>
    </div>
    <div class="pa-3">
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import titlePage from "../../../../components/atom/titlePage.vue";
import DialogSmall from "../../../dialog/dialogSmall.vue";
export default {
  name: "manageCourse",
  components: { titlePage, DialogSmall },
  data() {
    return {
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      dataSet: null,
      loading: false,
      calendar1: false,
      calendar2: false,
      time1: false,
      time2: false,
      categories: [
        { txt: "Lead Self", val: 1 },
        { txt: "Lead Others", val: 2 },
        { txt: "Professional Preparation", val: 3 },
      ],
      form: {
        title: "",
        category: 1,
        description: "",
        start_date: "",
        end_date: "",
        start_time: "00:00",
        end_time: "23:59",
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      let data = {
        path: `manage/course?filter[id]=${this.$route.params.idCourse}`,
      };
      this.$store.dispatch("course/getData", data).then((data) => {
        this.dataSet = data.data[0];
        this.dataSet.start_course = {
          ori: this.dataSet.start_course,
          fake: {
            start_date: this.$date(this.dataSet.start_course).format(
              "YYYY-MM-DD"
            ),
            start_time: this.$date(this.dataSet.start_course).format("HH:MM"),
          },
        };
        this.dataSet.end_course = {
          ori: this.dataSet.end_course,
          fake: {
            end_date: this.$date(this.dataSet.end_course).format("YYYY-MM-DD"),
            end_time: this.$date(this.dataSet.end_course).format("HH:MM"),
          },
        };
      });
    },
    toMainPage() {
      this.$router.push("/course/cr/list");
    },
    updateData() {
      this.loading = true;
      let start = `${this.dataSet.start_course.fake.start_date} ${this.dataSet.start_course.fake.start_time}`;
      let end = `${this.dataSet.end_course.fake.end_date} ${this.dataSet.end_course.fake.end_time}`;

      let body = {
        id: this.$route.params.idCourse,
        course_categories_id: this.dataSet.course_categories_id,
        title: this.dataSet.title,
        description: this.dataSet.description,
        start_course: this.$date(start).unix(),
        end_course: this.$date(end).unix(),
      };
      let data = {
        path: `manage/course/update`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    deleteCourse() {
      this.d_type = "d_course";
      this.d_title = "Delete Course";
      this.inventory = this.dataSet;
      this.d_small = true;
    },
    switchStatus(item) {
      this.d_type = "switch";
      item["module"] = "course";
      this.d_title = "";
      this.inventory = item;
      this.d_small = true;
    },
  },
};
</script>

<style scoped></style>
